module.exports = __webpack_public_path__ + "img/calendar.be3791dc.svg";